module.exports = __webpack_public_path__ + "static/img/logo.83a4067.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 19
// module chunks = 0